(function(){
  var def=function(n,c){if(!customElements.get(n))customElements.define(n,c)};
  var design=function(){return !!(window.Shopify&&window.Shopify.designMode)};

  def('rr-carousel',class extends HTMLElement{
    connectedCallback(){
      var self=this;this.track=this.querySelector('[data-track]');if(!this.track)return;
      this.loop=this.hasAttribute('loop');
      this.step=function(){var it=self.track.children[0];if(!it)return self.track.clientWidth;var g=parseFloat(getComputedStyle(self.track).columnGap)||0;return it.getBoundingClientRect().width+g};
      this.go=function(d){var max=self.track.scrollWidth-self.track.clientWidth;var x=self.track.scrollLeft+d*self.step();if(self.loop){if(x>max+4)x=0;else if(x<-4)x=max}self.track.scrollTo({left:x,behavior:(window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth')})};
      this.querySelectorAll('[data-prev]').forEach(function(b){b.addEventListener('click',function(){self.go(-1)})});
      this.querySelectorAll('[data-next]').forEach(function(b){b.addEventListener('click',function(){self.go(1)})});
      var dots=this.querySelector('[data-dots]');
      if(dots){
        var n=this.track.children.length;dots.innerHTML='';
        if(n>1){for(var i=0;i<n;i++){(function(i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Diapositive '+(i+1));b.addEventListener('click',function(){self.track.scrollTo({left:i*self.step(),behavior:(window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth')})});dots.appendChild(b)})(i)}}
        var upd=function(){var i=Math.round(self.track.scrollLeft/self.step());Array.prototype.forEach.call(dots.children,function(b,j){b.classList.toggle('is-on',j===i)})};
        this.track.addEventListener('scroll',function(){cancelAnimationFrame(self._r);self._r=requestAnimationFrame(upd)},{passive:true});upd();
      }
      var a=parseInt(this.dataset.autoplay||'0',10);
      if(a>0&&this.track.children.length>1&&!design()&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
        this.loop=true;
        var slides=Array.prototype.slice.call(this.track.children);
        var vids=slides.map(function(s){return s.querySelector('video')});
        if(!vids.some(Boolean)){
          var start=function(){clearInterval(self._t);self._t=setInterval(function(){self.go(1)},a*1000)};
          start();this.addEventListener('pointerenter',function(){clearInterval(self._t)});this.addEventListener('pointerleave',start);
        }else{
          /* Diaporama avec vidéo : on attend la fin de la vidéo avant de passer à la diapositive suivante */
          var cur=-1,hover=false;
          vids.forEach(function(v){if(v){v.loop=false;v.removeAttribute('loop')}});
          var stop=function(){clearTimeout(self._t);clearInterval(self._w)};
          var next=function(){stop();self.go(1)};
          var run=function(i){
            stop();var v=vids[i];
            vids.forEach(function(o,j){if(o&&j!==i)o.pause()});
            if(!v){if(!hover)self._t=setTimeout(next,a*1000);return}
            v.onended=function(){if(cur===i)next()};
            try{v.currentTime=0}catch(e){}
            var p=v.play();
            if(p&&p.catch)p.catch(function(){if(cur===i){stop();self._t=setTimeout(next,a*1000)}});
            var last=-1,still=0;
            self._w=setInterval(function(){if(cur!==i||v.paused&&!v.ended)return;if(v.currentTime===last){still+=2;if(still>=10)next()}else{last=v.currentTime;still=0}},2000);
          };
          var sync=function(){var i=Math.round(self.track.scrollLeft/self.step());if(i!==cur){cur=i;run(i)}};
          this.track.addEventListener('scroll',function(){clearTimeout(self._s);self._s=setTimeout(sync,150)},{passive:true});
          this.addEventListener('pointerenter',function(){hover=true;if(!vids[cur])clearTimeout(self._t)});
          this.addEventListener('pointerleave',function(){hover=false;if(!vids[cur]){clearTimeout(self._t);self._t=setTimeout(next,a*1000)}});
          sync();
        }
      }
    }
    disconnectedCallback(){clearInterval(this._t);clearTimeout(this._t);clearInterval(this._w);clearTimeout(this._s)}
  });

  def('rr-countdown',class extends HTMLElement{
    connectedCallback(){
      var self=this,raw=(this.dataset.end||'').trim().replace(' ','T'),end=new Date(raw),out=this.querySelector('[data-cd]'),host=this.closest('[data-rr-announce]');
      if(!raw||isNaN(end.getTime())){this.hidden=true;return}
      var p=function(n){return String(n).padStart(2,'0')};
      var tick=function(){var s=Math.floor((end-Date.now())/1000);
        if(s<=0){self.hidden=true;clearInterval(self._i);if(host&&self.dataset.hide==='true'&&!design())host.hidden=true;return}
        self.hidden=false;var d=Math.floor(s/86400);s%=86400;
        out.textContent=(d?d+'J ':'')+p(Math.floor(s/3600))+'H '+p(Math.floor(s%3600/60))+'M '+p(s%60)+'S'};
      tick();this._i=setInterval(tick,1000);
    }
    disconnectedCallback(){clearInterval(this._i)}
  });

  def('rr-quiz',class extends HTMLElement{
    connectedCallback(){
      var self=this;this.steps=Array.prototype.slice.call(this.querySelectorAll('[data-step]'));this.ans={};
      this.bar=this.querySelector('[data-bar]');this.count=this.querySelector('[data-count]');this.res=this.querySelector('[data-result]');
      this.addEventListener('click',function(e){
        var o=e.target.closest('[data-opt]');
        if(o){var s=parseInt(o.closest('[data-step]').dataset.step,10);self.ans[s]=o.dataset;self.show(s+1);return}
        if(e.target.closest('[data-back]'))self.show(Math.max(0,self.cur-1));
        if(e.target.closest('[data-restart]')){self.ans={};self.show(0)}
      });
      this.show(0);
    }
    show(i){
      var n=this.steps.length,done=i>=n;this.cur=i;
      this.steps.forEach(function(s,j){s.hidden=j!==i});
      if(this.res)this.res.hidden=!done;
      if(this.bar)this.bar.style.width=(done?100:((i+1)/n*100))+'%';
      if(this.count)this.count.textContent=(done?n:i+1)+'/'+n;
      if(done)this.fill();
    }
    fill(){
      var a=this.ans,r=this.res;if(!r)return;
      var set=function(k,v){r.querySelectorAll('[data-r-'+k+']').forEach(function(el){el.textContent=v||''})};
      set('problem',a[0]&&a[0].label);set('reco',a[0]&&a[0].reco);
      set('room',a[1]&&a[1].label?a[1].label.toLowerCase():'');set('tip',a[2]&&a[2].tip);
      var tip=r.querySelector('[data-tipbox]');if(tip)tip.hidden=!(a[2]&&a[2].tip);
      var btn=r.querySelector('[data-r-link]');if(btn&&a[0]&&a[0].url)btn.href=a[0].url;
    }
  });

  def('rr-savings',class extends HTMLElement{
    connectedCallback(){var self=this;this.inputs=Array.prototype.slice.call(this.querySelectorAll('input[type=range]'));this.inputs.forEach(function(i){i.addEventListener('input',function(){self.calc()})});this.calc()}
    calc(){
      var self=this,v=function(n){var el=self.querySelector('[name='+n+']');return el?parseFloat(el.value):0};
      var fmt=function(x){return Math.round(x).toLocaleString('fr-FR')+' €'};
      this.inputs.forEach(function(i){var o=self.querySelector('[data-out='+i.name+']');if(o)o.textContent=parseFloat(i.value).toLocaleString('fr-FR')+(i.dataset.unit||'');i.style.setProperty('--p',((i.value-i.min)/(i.max-i.min)*100)+'%')});
      var win=parseFloat(this.dataset.win)/100,gain=parseFloat(this.dataset.gain)/100;
      var loss=v('bill')*win,save=loss*(v('equip')/100)*gain;
      this.q('loss',fmt(loss));this.q('save',fmt(save));
    }
    q(k,t){this.querySelectorAll('[data-o-'+k+']').forEach(function(e){e.textContent=t})}
  });

  def('rr-bars',class extends HTMLElement{
    connectedCallback(){
      var el=this.querySelector('.rr-bars');if(!el)return;
      if(!('IntersectionObserver' in window)||design()){el.classList.add('is-in');return}
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){el.classList.add('is-in');io.disconnect()}})},{threshold:.3});io.observe(el);
    }
  });
})();